import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

const HideColumnsMenuStyles = makeStyles((theme: Theme) =>
    createStyles({
        menuWrapper: {
            borderRadius: 6,
        },
        itemHeader: {
            background: theme.palette.background.grey,
            padding: theme.spacing(1.5, 2.5),
        },
        itemHeaderTitle: {
            fontSize: 16,
            fontWeight: 700,
            letterSpacing: 0.5,
            color: theme.palette.text.primary,
        },
        itemHeaderSubtitle: {
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: 0.4,
            color: theme.palette.text.disabled,
        },
        menuItem: {
            padding: theme.spacing(0.5, 1),
            "& .MuiTypography-root": {
                fontSize: 15,
                fontWeight: 500,
            },
        },
        resetButton: {
            color: theme.palette.button.active.to,
            padding: 1,
            justifyContent: "end",
            "&.Mui-disabled": {
                cursor: "none",
                color: theme.palette.text.disabled,
            },
        },
    })
);

export default HideColumnsMenuStyles;
